
import EDPanel from '../../../../../BaseComponents/Panel/EDPanel';
import EDIcon from '../../../../../BaseComponents/Icon/EDIcon';
import EDIconButton from '../../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import Bakgrundsjobb from '../../../../../Components/Bakgrundsjobb/Bakgrundsjobb';
import BakgrundsjobbQuery from '../../../../../Components/Bakgrundsjobb/BakgrundsjobbQuery';

const BakgrundsjobbPanel: React.FC<React.PropsWithChildren<{}>> = () => {
  return (
    <EDPanel
      title="Beställda jobb"
      avatar={<EDIcon color="action" iconType="build" size="large" />}
      headerPadding="normal"
      titleAction={
        <EDIconButton
          tooltip=""
          onClick={() => {}}
          icon="more_vert"
          margin="none"
        />
      }
      flex
    >
      <BakgrundsjobbQuery>
        {jobb => <Bakgrundsjobb jobb={jobb} />}
      </BakgrundsjobbQuery>
    </EDPanel>
  );
};

export default BakgrundsjobbPanel;
